import { computed, Inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { JwtHelperService } from '@auth0/angular-jwt';

import {
	AbstractProfileService,
	AbstractStorageService,
	AlarisConfigService,
	LOCALSTORAGE_SERVICE_INJECTOR,
	PROFILE_SERVICE_INJECTOR,
} from '@campaign-portal/components-library';
import { ProfileProvider, ProfileUser } from '@campaign-portal/contracts/profile';
import { UserDetailsSubset } from '../types';
import { PublicImageUrl } from '../utils';

@Injectable({ providedIn: 'root' })
export class AlarisProfileAdapter extends ProfileProvider {
	private readonly raw = toSignal(this.source.user$, { initialValue: this.source.user });

	readonly user: Signal<ProfileUser> = computed(() => {
		const u = this.raw();
		const details = (u.details ?? {}) as UserDetailsSubset;
		const first = details.firstName ?? '';
		const last = details.lastName ?? '';
		const full = `${first} ${last}`.trim();
		return {
			displayName: full || u.login || u.email,
			email: u.email,
			is2FAEnabled: u.isEnable2FA,
			photoUrl: details.photoUrl ? new PublicImageUrl(this.config.api, details.photoUrl).value() : null,
		};
	});

	readonly isImpersonate: Signal<boolean> = computed(() => {
		this.raw();
		return this.detectImpersonate();
	});

	constructor(
		@Inject(PROFILE_SERVICE_INJECTOR) private readonly source: AbstractProfileService,
		@Inject(LOCALSTORAGE_SERVICE_INJECTOR) private readonly storage: AbstractStorageService,
		private readonly config: AlarisConfigService
	) {
		super();
	}

	private detectImpersonate(): boolean {
		const token = this.storage.get('token');
		if (!token) return false;
		const data = new JwtHelperService().decodeToken<{ impersonator?: unknown }>(token);
		return Boolean(data && typeof data === 'object' && 'impersonator' in data && data.impersonator);
	}
}
